import { render, staticRenderFns } from "./singleproduct.vue?vue&type=template&id=e7846564&scoped=true"
import script from "./singleproduct.vue?vue&type=script&lang=js"
export * from "./singleproduct.vue?vue&type=script&lang=js"
import style0 from "./singleproduct.vue?vue&type=style&index=0&id=e7846564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7846564",
  null
  
)

export default component.exports